import { Card, Divider, Empty, List, Tag } from 'antd'
import React from 'react'
import bin_img from '../../../assets/dashboard/bin_img.png';

const BinTransitView = ({ binsToDisplay, onCardClick  }) => {

  return (
    <>
      <div style={{ textAlign: 'right', paddingBottom: '10px' }}>

      </div>
      <div style={{ marginTop: 16 }}>
        {binsToDisplay.length > 0 ? (
          <List
            grid={{
              gutter: 16,
              xs: 1,
              sm: 2,
              md: 3,
              lg: 4,
              xl: 5,
            }}
            dataSource={binsToDisplay}
            renderItem={(bin) => (
              <>
                <List.Item>
                  <>
                    {bin.bin_location && (
                      <Tag
                        color={
                          bin.bin_location === "washing"
                            ? "#87CEEB" // Sky Blue for washing
                            : bin.bin_location === "dispatch_center"
                              ? "#800080" // Purple for dispatch_center
                              : bin.bin_location === "garment_super_market"
                                ? "#FFC0CB" // Pink for garment_super_market
                                : bin.bin_location === "In Transit"
                                  ? "#FFFF00" // Yellow for In Transit
                                  : "#000000" // Default color if no match
                        }
                        style={{
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center',
                          whiteSpace: 'nowrap',
                          color:
                            bin.bin_location === "washing"
                              ? "#000000" // Black text for Sky Blue
                              : bin.bin_location === "dispatch_center"
                                ? "#FFFFFF" // White text for Purple
                                : bin.bin_location === "garment_super_market"
                                  ? "#000000" // Black text for Pink
                                  : bin.bin_location === "In Transit"
                                    ? "#000000" // Black text for Yellow
                                    : "#FFFFFF", // Default text color for Black
                          width: '50%',
                          height: '100%',
                          textAlign: 'center',
                          fontWeight: 'bold',
                        }}
                      >
                        {bin.movement_status} -
                        {bin.bin_to === "washing"
                          ? "Washing"
                          : bin.bin_to === "dispatch_center"
                            ? "Transit Center"
                            : bin.bin_to === "garment_super_market"
                              ? "G S M"
                              : bin.bin_to === "In Transit"
                                ? "In Transit"
                                : "Unknown"}
                      </Tag>
                    )}
                    <Card
                      bordered={false}
                      size="small"
                      style={{
                        textAlign: "center",
                        borderRadius: 8,
                        width: '50%',
                        height: '50%',
                        boxShadow: 'none',
                        cursor: 'pointer', // Added to show it's clickable
                      }}
                      onClick={() => onCardClick(bin)}
                      cover={<img src={bin_img}
                        style={{ marginBottom: '-20px' }} />
                      }
                    >
                      <div style={{
                        position: 'absolute',
                        top: '53%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        whiteSpace: 'nowrap'
                      }}>
                        <p style={{
                          height: 24,
                          color: 'black',
                        }} size='small'><strong>{bin.bin_name}</strong></p>
                      </div>
                    </Card>
                    <Tag
                      color={bin.bin_full === "yes" ? "#87d068" : "transparent"}
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        whiteSpace: "nowrap",
                        marginBottom: "-10px",
                        color: bin.bin_full === "yes" ? "white" : "black",
                        width: "50%",
                        height: "100%",
                        textAlign: "center",
                        fontWeight: "bold",
                        border: bin.bin_full === "yes" ? "none" : "1px solid black",
                      }}
                    >
                      {bin.total_qty || 0} Pcs
                    </Tag>
                  </>
                </List.Item>
                <Divider />
              </>
            )}
          />
        ) : (
          <Empty description="No Bins Found This Location(s)" />
        )}
      </div>

    </>
  )
}

export default BinTransitView